module.exports = __webpack_public_path__ + "static/media/yearbook.ad8a12c1.svg";